/*
 * policies/constants.js
 *
 * Ensure each action has a corresponding type here.
 * To avoid reducer conflicts, these should be prefixed
 * with the parent directory.
 */

// Policies VirtualizedTable parameters in px
export const POLICIES_TABLE_ROW_HEIGHT = 36;

export const CHECK_CRBS_CONFIGURED_START =
  "policies/CHECK_CRBS_CONFIGURED_START";
export const CHECK_CRBS_CONFIGURED_SUCCESS =
  "policies/CHECK_CRBS_CONFIGURED_SUCCESS";

export const FETCH_PRODUCTS = "policies/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_START = "policies/FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "policies/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILED = "policies/FETCH_PRODUCTS_FAILED";
export const SET_CURRENT_PRODUCT = "policies/SET_CURRENT_PRODUCT";

export const ADD_SERVICE_START = "policies/ADD_SERVICE_START";
export const ADD_SERVICE_SUCCESS = "policies/ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAILED = "policies/ADD_SERVICE_FAILED";
export const ADD_SERVICE_WITH_ADMIN_START =
  "policies/ADD_SERVICE_WITH_ADMIN_START";
export const ADD_SERVICE_WITH_ADMIN_SUCCESS =
  "policies/ADD_SERVICE_WITH_ADMIN_SUCCESS";
export const ADD_SERVICE_WITH_ADMIN_FAILED =
  "policies/ADD_SERVICE_WITH_ADMIN_FAILED";

export const REMOVE_SERVICE_START = "policies/REMOVE_SERVICE_START";
export const REMOVE_SERVICE_SUCCESS = "policies/REMOVE_SERVICE_SUCCESS";
export const REMOVE_SERVICE_FAILED = "policies/REMOVE_SERVICE_FAILED";

export const FETCH_SERVICES = "policies/FETCH_SERVICES";
export const FETCH_SERVICES_START = "policies/FETCH_SERVICES_START";
export const FETCH_SERVICES_SUCCESS = "policies/FETCH_SERVICES_SUCCESS";
export const FETCH_SERVICES_FAILED = "policies/FETCH_SERVICES_FAILED";
export const SET_CURRENT_SERVICE = "policies/SET_CURRENT_SERVICE";
export const SET_SERVICES_FILTER_TERM = "policies/SET_SERVICES_FILTER_TERM";

export const REGISTER_SERVICE_START = "policies/REGISTER_SERVICES_START";
export const REGISTER_SERVICE_SUCCESS = "policies/REGISTER_SERVICES_SUCCESS";
export const REGISTER_SERVICE_FAILED = "policies/REGISTER_SERVICES_FAILED";

export const FETCH_RESOURCES = "policies/FETCH_RESOURCES";
export const FETCH_RESOURCES_START = "policies/FETCH_RESOURCES_START";
export const FETCH_RESOURCES_SUCCESS = "policies/FETCH_RESOURCES_SUCCESS";
export const FETCH_RESOURCES_FAILED = "policies/FETCH_RESOURCES_FAILED";
export const SET_CURRENT_RESOURCE = "policies/SET_CURRENT_RESOURCE";
export const SET_FIRST_RESOURCE_IN_SERVICE =
  "policies/SET_FIRST_RESOURCE_IN_SERVICE";
export const REMOVE_RESOURCE = "policies/REMOVE_RESOURCE";

export const FETCH_RESOURCE_TYPES = "policies/FETCH_RESOURCE_TYPES";
export const FETCH_RESOURCE_TYPES_START = "policies/FETCH_RESOURCE_TYPES_START";
export const FETCH_RESOURCE_TYPES_SUCCESS =
  "policies/FETCH_RESOURCE_TYPES_SUCCESS";
export const FETCH_RESOURCE_TYPES_FAILED =
  "policies/FETCH_RESOURCE_TYPES_FAILED";
export const SET_CURRENT_RESOURCE_TYPE = "policies/SET_CURRENT_RESOURCE_TYPE";

export const ADD_USER_START = "policies/ADD_USER_START";
export const ADD_USER_SUCCESS = "policies/ADD_USER_SUCCESS";
export const ADD_USER_FAILED = "policies/ADD_USER_FAILED";
export const REMOVE_USER_START = "policies/REMOVE_USER_START";
export const REMOVE_USER_SUCCESS = "policies/REMOVE_USER_SUCCESS";
export const REMOVE_USER_FAILED = "policies/REMOVE_USER_FAILED";
export const FETCH_USERS = "policies/FETCH_USERS";
export const FETCH_USERS_START = "policies/FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "policies/FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILED = "policies/FETCH_USERS_FAILED";
export const SET_CURRENT_USER = "policies/SET_CURRENT_USER";

export const FETCH_GROUPS = "policies/FETCH_GROUPS";
export const FETCH_GROUPS_START = "policies/FETCH_GROUPS_START";
export const FETCH_GROUPS_SUCCESS = "policies/FETCH_GROUPS_SUCCESS";
export const FETCH_GROUPS_FAILED = "policies/FETCH_GROUPS_FAILED";
export const ADD_GROUP_START = "policies/ADD_GROUP_START";
export const ADD_GROUP_SUCCESS = "policies/ADD_GROUP_SUCCESS";
export const ADD_GROUP_FAILED = "policies/ADD_GROUP_FAILED";
export const REMOVE_GROUP_START = "policies/REMOVE_GROUP_START";
export const REMOVE_GROUP_SUCCESS = "policies/REMOVE_GROUP_SUCCESS";
export const REMOVE_GROUP_FAILED = "policies/REMOVE_GROUP_FAILED";
export const SET_CURRENT_GROUP = "policies/SET_CURRENT_GROUP";

export const SET_USERS_GROUPS_FILTER_TERM =
  "policies/SET_USERS_GROUPS_FILTER_TERM";

export const FETCH_ROLES = "policies/FETCH_ROLES";
export const FETCH_ROLES_START = "policies/FETCH_ROLES_START";
export const FETCH_ROLES_SUCCESS = "policies/FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILED = "policies/FETCH_ROLES_FAILED";
export const SET_CURRENT_ROLE = "policies/SET_CURRENT_ROLE";
export const SET_ROLES_FILTER_TERM = "policies/SET_ROLES_FILTER_TERM";

export const FETCH_PERMISSIONS = "policies/FETCH_PERMISSIONS";
export const FETCH_PERMISSIONS_START = "policies/FETCH_PERMISSIONS_START";
export const FETCH_PERMISSIONS_SUCCESS = "policies/FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILED = "policies/FETCH_PERMISSIONS_FAILED";

export const FETCH_POLICIES = "policies/FETCH_POLICIES";
export const FETCH_POLICIES_START = "policies/FETCH_POLICIES_START";
export const FETCH_POLICIES_SUCCESS = "policies/FETCH_POLICIES_SUCCESS";
export const FETCH_POLICIES_FAILED = "policies/FETCH_POLICIES_FAILED";
export const ADD_POLICY = "policies/ADD_POLICY";
export const REMOVE_POLICY_START = "policies/REMOVE_POLICY_START";
export const REMOVE_POLICY_SUCCESS = "policies/REMOVE_POLICY_SUCCESS";
export const REMOVE_POLICY_FAILED = "policies/REMOVE_POLICY_FAILED";
export const REMOVE_POLICY_CANCEL = "policies/REMOVE_POLICY_CANCEL";
export const REMOVE_DIRTY_POLICY = "policies/REMOVE_DIRTY_POLICY";
export const MARK_POLICY_FOR_UPDATE = "policies/MARK_POLICY_FOR_UPDATE";
export const MARK_POLICY_FOR_DELETE = "policies/MARK_POLICY_FOR_DELETE";
export const MARK_POLICY_CLEAN = "policies/MARK_POLICY_CLEAN";
export const COMMIT_POLICIES_START = "policies/COMMIT_POLICIES_START";
export const COMMIT_ADD_POLICIES_SUCCESS =
  "policies/COMMIT_ADD_POLICIES_SUCCESS";
export const COMMIT_DELETE_POLICIES_SUCCESS =
  "policies/COMMIT_DELETE_POLICIES_SUCCESS";
export const COMMIT_POLICIES_FAILED = "policies/COMMIT_POLICIES_FAILED";

export const ADD_GLOBAL_ADMIN_START = "policies/ADD_GLOBAL_ADMIN_START";
export const ADD_GLOBAL_ADMIN_SUCCESS = "policies/ADD_GLOBAL_ADMIN_SUCCESS";
export const ADD_GLOBAL_ADMIN_FAILED = "policies/ADD_GLOBAL_ADMIN_FAILED";

export const FETCH_CHANGESETS = "policies/FETCH_CHANGESETS";
export const FETCH_CHANGESETS_START = "policies/FETCH_CHANGESETS_START";
export const FETCH_CHANGESETS_SUCCESS = "policies/FETCH_CHANGESETS_SUCCESS";
export const FETCH_CHANGESETS_FAILED = "policies/FETCH_CHANGESETS_FAILED";
export const ADD_CHANGESET_START = "policies/ADD_CHANGESET_START";
export const ADD_CHANGESET_SUCCESS = "policies/ADD_CHANGESET_SUCCESS";
export const ADD_CHANGESET_FAILED = "policies/ADD_CHANGESET_FAILED";

export const UNDO_REMOVE_POLICY_TIMER = 5000;
